import React from "react";
import { Card, Table, Layout, Space, Button } from "antd";
import { SortOrder } from "antd/lib/table/interface";
import { fmtDateTime } from "../../../common/Utils";
import { usePosts } from "../../../hooks/content/usePosts";
import { FiltersBar } from "../../../components/filter/FiltersBar";

export const Posts = () => {
  const { data, sortedInfo, pagination, loading, filters, del, setFilters, refresh, reset, onSearch, setSortedInfo } =
    usePosts();

  const onChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title.keyword",
      sorter: true,
      // render: (v, r) => <a onClick={() => store.publishStore.show(r.id)}>{v}</a>,
      sortOrder: sortedInfo.columnKey === "Title.keyword" ? (sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type.keyword",
      sorter: true,
      sortOrder: sortedInfo.columnKey === "Type.keyword" ? (sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Platform",
      dataIndex: "Platform",
      key: "Platform",
      render: (x) => x?.join(","),
    },
    {
      title: "Create Date",
      dataIndex: "CreatedAt",
      key: "CreatedAt",
      render: fmtDateTime,
      sorter: true,
      sortOrder: sortedInfo.columnKey === "CreatedAt" ? (sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "",
      render: (_, r) => (
        <Space>
          {r.Deleted ? (
            "Deleted"
          ) : (
            <Button type="link" onClick={() => del(r)}>
              Delete
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <FiltersBar
        filters={filters}
        cfg={{}}
        search={onSearch}
        refresh={refresh}
        reset={reset}
        setFilters={setFilters}
        actionsSpan={8}
      ></FiltersBar>

      <Card size="small">
        <Table
          size="small"
          pagination={pagination}
          loading={loading}
          rowKey="PostId"
          columns={columns}
          dataSource={data.items}
          onChange={onChange}
        />
      </Card>
    </Layout.Content>
  );
};
